import React, { useState } from 'react'
import { Formik } from 'formik'
import * as Yup from 'yup'
import { Col, Form, Modal, Row } from 'react-bootstrap';
import '../../../css/AdminModal.css'
import Swal from 'sweetalert2'
import axios from 'axios';

const EditProjects = (props) => {

    const [showModal, setShowModal] = useState(false)

    const validateProjectSchema = Yup.object().shape({
        projectName: Yup.string()
            .required('Project Name Is Required !'),
        // location: Yup.string()
        //     .required('Location Is Required !')
    })

    return (

        <>

            <div className="edit-icon">
                <i className="bi bi-pencil-square btn-sm" onClick={() => setShowModal(true)} />
            </div>

            <div className="activity-modal">
                <Modal show={showModal} onHide={() => setShowModal(false)} size='lg' centered>
                    <Modal.Header style={{ background: '#2DA92D' }}>
                        <Modal.Title>
                            <div className="modal-title">
                                <h3>Edit Project</h3>
                            </div>
                        </Modal.Title>
                        <button className='modal-close-btn1' onClick={() => setShowModal(false)}>
                            <i className='bi bi-x cross1' />
                        </button>
                    </Modal.Header>
                    <Modal.Body style={{ backgroundColor: "#f2f2f2" }}>
                        <div className="body-activity">
                            <Formik
                                initialValues={{ projectID: props.EditProject.projectID, projectName: props.EditProject.projectName, location: props.EditProject.location }}
                                validationSchema={validateProjectSchema}
                                onSubmit={(values, { resetForm }) => {
                                    Swal.fire({
                                        title: 'Do you want to update Project?',
                                        showDenyButton: true,
                                        showCancelButton: true,
                                        confirmButtonText: 'Update',
                                        denyButtonText: `Don't Update`,
                                    }).then((result) => {
                                        if (result.isConfirmed) {
                                            axios.put(`${process.env.REACT_APP_BASEURL}/projects/${props.EditProject.projectID}`, values)
                                                .then(res => {
                                                    // console.log(res.data)
                                                    if (res.data.status === "Success") {
                                                        Swal.fire('Updated!', '', 'success')
                                                    }
                                                    else {
                                                        Swal.fire('Error!', '', 'error')
                                                    }
                                                })
                                        }
                                        else if (result.isDenied) {
                                            Swal.fire('Unable to update', '', 'error')
                                        }
                                    }).then(console.log(values)).then(resetForm()).then(setShowModal(false))
                                }}
                            >
                                {({ values, errors, touched, handleChange, handleSubmit }) => (
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group as={Row} className='mb-2'>
                                            <Form.Label column sm='4' className='label2'>PROJECT ID :</Form.Label>
                                            <Col sm='3'>
                                                <Form.Control id='projectID' type='text' name='projectID' placeholder='Enter Project ID *' onChange={handleChange} defaultValue={values.projectID} style={{ borderColor: touched.projectID && errors.projectID ? 'red' : '#2DA92D' }} disabled />
                                                {touched.projectID && errors.projectID ? (
                                                    <Col className="error-message">{errors.projectID}</Col>
                                                ) : null}
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className='mb-2'>
                                            <Form.Label column sm='4' className='label2'>PROJECT NAME :</Form.Label>
                                            <Col sm='5'>
                                                <Form.Control id='projectName' type='text' name='projectName' placeholder='Enter Project Name *' onChange={handleChange} defaultValue={values.projectName} style={{ borderColor: touched.projectName && errors.projectName ? 'red' : '#2DA92D' }} />
                                                {touched.projectName && errors.projectName ? (
                                                    <Col className="error-message">{errors.projectName}</Col>
                                                ) : null}
                                            </Col>
                                        </Form.Group>
                                        <Form.Group as={Row} className='mb-2'>
                                            <Form.Label column sm='4' className='label2'>PROJECT LOCATION :</Form.Label>
                                            <Col sm='5'>
                                                <Form.Control id='location' type='text' name='location' placeholder='Enter Project Location' onChange={handleChange} defaultValue={values.location} style={{ borderColor: touched.location && errors.location ? 'red' : '#2DA92D' }} />
                                                {touched.location && errors.location ? (
                                                    <Col className="error-message">{errors.location}</Col>
                                                ) : null}
                                            </Col>
                                        </Form.Group>
                                        <Modal.Footer className='modal-footer'>
                                            <button type='submit'>SAVE</button>
                                            {/* <button onClick={() => setShowModal(false)}>CANCEL</button> */}
                                        </Modal.Footer>
                                    </Form>
                                )}
                            </Formik>
                        </div>
                    </Modal.Body>
                </Modal>
            </div>

        </>

    )
}

export default EditProjects
